export default "/_next/static/src/assets/videos/1b2fb1a496b96bd7bcc76a49035e3981.mp4";